// METHODS
import formatTime from './formatTime';
import formatDate from './formatDate';
import timeAgo from './timeAgo';
import formatShortDate from './formatShortDate';
import getAvatar from './getAvatar';
import formatTableDate from './formatTableDate';
import selectSearchFilter from './selectSearchFilter';
import formatDatePickerTime from './formatDatePickerTime';

const GeneralHelpers = {
  formatTime,
  formatShortDate,
  formatDate,
  timeAgo,
  formatTableDate,
  getAvatar,
  selectSearchFilter,
  formatDatePickerTime,
};

export default GeneralHelpers;



// WEBPACK FOOTER //
// ./src/lib/helpers/GeneralHelpers/index.js